import React, { Fragment, useState } from 'react';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/business/Footer/Footer';
import Bg from '../../images/backgrounds/onze_diensten_image.webp';
import srImg from '../../images/services/quickscan/quickscan_info.webp';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "reactstrap";
import CtaSection from "../../components/CtaSection/CtaSection";

const steps = [
    {
        id: 1,
        title: "Betrokkenheid",
        description: "Wij waarderen de persoonlijke aanpak en korte lijnen die typisch zijn voor het MKB. Dit maakt samenwerken effectief en prettig.",
    },
    {
        id: 2,
        title: "Impact",
        description: "Een cyberaanval kan voor een klein of middelgroot bedrijf desastreus zijn. Door het MKB te helpen, maken we een directe impact door bedrijven en banen te beschermen.",
    },
    {
        id: 3,
        title: "Toegankelijkheid",
        description: "Het MKB heeft vaak geen toegang tot complexe en dure IT-oplossingen. Wij willen dat veranderen door innovatieve beveiliging betaalbaar te maken.",
    },
];

const MKBPage = (props) => {

    const [activeStep, setActiveStep] = useState(1);

    const handleStepClick = (stepId) => {
        setActiveStep(stepId);
    };

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Waarom richten wij ons op MKB?'} bgImage={Bg} />
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-5 order-lg-first">
                                <div className="team_cartoon_image">
                                    <img src={srImg} alt="Service Cartoon"/>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="sectoren_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text">
                                            Cybersecurity op maat voor het midden- en kleinbedrijf (MKB)
                                        </h2>
                                        <p className="heading_description mb-0">
                                            Het MKB vormt de ruggengraat van de Nederlandse economie en is verantwoordelijk voor een groot deel van de innovatie, werkgelegenheid en groei in ons land. Tegelijkertijd staat het MKB voor unieke uitdagingen op het gebied van cybersecurity en IT-compliance. Bij Praeventor begrijpen we deze uitdagingen en bieden we oplossingen die speciaal zijn afgestemd op de behoeften van MKB-bedrijven.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="pt-130"></div>

                {/* Focusgebieden */}
                <section className="section_space bg-white">
                    <div className="container">
                        <h3 className="text-center mb-5">De uitdagingen van het MKB in cybersecurity</h3>
                        <p className="heading_description mb-5 pb-80">
                            De keuze om ons op het MKB te richten is gebaseerd op de specifieke problemen waar ondernemers in deze sector dagelijks mee te maken krijgen. Denk bijvoorbeeld aan:
                        </p>
                        <div className="partners_faq accordion" id="partners_faq">
                            <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="1">
                                        Beperkte middelen
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="1" className="acc_body">
                                            <p>
                                                MKB-bedrijven hebben vaak geen uitgebreide IT-afdeling of cybersecurity-specialist in huis. Dit maakt het lastig om complexe cyberdreigingen en regelgeving zelf te beheren.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="2">
                                        Hoge kosten van beveiliging
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="2" className="acc_body">
                                            <p>
                                                Veel MKB’ers denken dat geavanceerde beveiligingsoplossingen alleen toegankelijk zijn voor grote bedrijven vanwege de hoge kosten. Dit kan leiden tot een gebrek aan adequate bescherming.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="3">
                                        Groeiende cyberdreigingen
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="3" className="acc_body">
                                            <p>
                                                Hackers richten zich steeds vaker op kleinere bedrijven, omdat deze vaak minder goed beveiligd zijn. Phishing, ransomware en datalekken vormen directe risico's.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="4">
                                        Wet- en regelgeving
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="4" className="acc_body">
                                            <p>
                                                Het voldoen aan wetten zoals de AVG (GDPR), NIS2 en branche-specifieke regels is complex en tijdrovend, terwijl niet-naleving kan leiden tot hoge boetes en reputatieschade.
                                            </p>
                                        </AccordionBody>

                                    </div>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </section>

                {/*  Waarom kiezen bedrijven voor ons?  */}
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between" style={{ padding: "100px"}}>
                            <div className="col-lg-12">
                                <div className="sectoren_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text text-center">
                                            Waarom kiezen MKB-bedrijven voor Praeventor?
                                        </h2>
                                        <p className="heading_description mb-0 text-center">
                                            Wij hebben ons gespecialiseerd in het ondersteunen van MKB-organisaties, omdat wij geloven dat goede cybersecurity en compliance voor iedereen toegankelijk moeten zijn. Ons team biedt oplossingen die betaalbaar, schaalbaar en praktisch zijn.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="process_technology_review_section section_decoration">
                    <div className="container">
                        <div className="heading_block mb-5">
                            <h2 className="heading_text mb-0">
                                Wat maakt <mark>MKB</mark> aantrekkelijk voor ons?
                            </h2>
                        </div>

                        <div className="steps_container">
                            {steps.map((step, index) => (
                                <div
                                    key={step.id}
                                    className={`step_item ${activeStep === step.id ? 'active' : ''}`}
                                    onClick={() => handleStepClick(step.id)}
                                    style={{
                                        backgroundColor: activeStep === step.id ? '#f0f0f5' : 'white',
                                        border: '1px solid #e0e0e0',
                                        padding: '20px',
                                        marginBottom: '20px',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                    }}
                                >
                                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#2c3e50' }}>
                                        {`${step.id}. ${step.title}`}
                                    </div>
                                    <div style={{ marginTop: '10px', color: '#555' }}>
                                        {activeStep === step.id && <p>{step.description}</p>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default MKBPage;
